import React from "react"

export const StatusChip = ({ on, onText, offText }) => (
    <span className={"listing-chip " + (on ? "listing-chip--on" : "listing-chip--off")}>
        <i className={"fa " + (on ? "fa-check" : "fa-times")} aria-hidden="true"></i>
        {on ? onText : offText}
    </span>
)

export const VisibilityChip = ({ visible }) => (
    <span className={"listing-chip listing-chip--visibility " + (visible ? "listing-chip--on" : "listing-chip--off")}>
        <i className={"fa " + (visible ? "fa-eye" : "fa-eye-slash")} aria-hidden="true"></i>
        {visible ? "Visible" : "Hidden"}
    </span>
)

export const formatDateRange = (startIso, endIso) => {
    if (!startIso || !endIso) return "--"
    const options = { month: "short", day: "numeric" }
    const start = new Date(startIso + "T00:00:00")
    const end = new Date(endIso + "T00:00:00")
    return `${start.toLocaleDateString("en-US", options)} – ${end.toLocaleDateString("en-US", options)}, ${end.getFullYear()}`
}
